export default "__VITE_ASSET__DFwu7y1M__"